export default __webpack_public_path__ + "static/media/t2.25c47166.jpg";